/* ==============================================
   assets/video-slider.js
   ============================================== */

(function () {
  'use strict';

  function loadSwiper(cb) {
    if (window.Swiper) { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function loadLazyLoad(cb) {
    if (window.LazyLoad) { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/vanilla-lazyload@19.1.3/dist/lazyload.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  function stopVideo(v) {
    v.removeAttribute('autoplay');
    v.pause();
    v.currentTime = 0;
  }

function initSlider(swiperEl) {
  if (!swiperEl) return;

  swiperEl.querySelectorAll('video').forEach(function (v) {
    stopVideo(v);
    v.setAttribute('preload', 'auto');        // ✅ force preload on all videos
    v.setAttribute('playsinline', '');        // ✅ required for iOS inline playback
    v.setAttribute('webkit-playsinline', ''); // ✅ older iOS Safari
    v.load();                                 // ✅ trigger load immediately
  });

  swiperEl.classList.remove('preview');

  // Fix blurry posters
  swiperEl.querySelectorAll('video[poster]').forEach(function (v) {
    v.poster = v.poster.replace(/_small\.jpg/, '_large.jpg');
  });

  var coverflowEffect = {
    rotate: 0,
    stretch: 0,
    depth: 0,
    scale: 0.9,
    modifier: 1,
    slideShadows: true
  };

  var wrapper = swiperEl.closest('.u-video-slider__wrapper');
  var btnPrev = wrapper ? wrapper.querySelector('.u-video-slider__btn--prev') : null;
  var btnNext = wrapper ? wrapper.querySelector('.u-video-slider__btn--next') : null;

  var swiper = new Swiper(swiperEl, {
    effect: 'coverflow',
    centeredSlides: true,
    loop: true,
    loopedSlides: 20,
    slidesPerView: 'auto',
    spaceBetween: 8,
    coverflowEffect: coverflowEffect,
    navigation: {
      prevEl: btnPrev,
      nextEl: btnNext
    },
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 8,
        coverflowEffect: coverflowEffect
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 8,
        coverflowEffect: coverflowEffect
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 8,
        coverflowEffect: coverflowEffect
      }
    },
    on: {
      beforeInit: function () {
        swiperEl.querySelectorAll('video').forEach(function (v) {
          stopVideo(v);
        });
      },
      init: function () {
        pauseAll();
        playActive(this);
        preloadNeighbours(this); // ✅ preload adjacent slides on init
      },
      slideChange: function () {
        pauseAll();
        playActive(this);
        preloadNeighbours(this); // ✅ preload adjacent slides on every change
      }
    }
  });

  function pauseAll() {
    swiperEl.querySelectorAll('video').forEach(function (v) {
      v.pause();
    });
  }

  function playActive(sw) {
    var activeSlide = sw.slides[sw.activeIndex];
    if (!activeSlide) return;
    var v = activeSlide.querySelector('video');
    if (v) {
      v.removeAttribute('autoplay');
      v.currentTime = 0;          // ✅ reset so it starts from beginning
      var playPromise = v.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // iOS blocked autoplay — wait for user interaction then retry
          document.addEventListener('touchstart', function retryPlay() {
            v.play().catch(function () {});
            document.removeEventListener('touchstart', retryPlay);
          }, { once: true });
        });
      }
    }
  }

  // ✅ Preload video in prev/next slides so they're ready before user swipes
  function preloadNeighbours(sw) {
    var indices = [sw.activeIndex - 1, sw.activeIndex + 1, sw.activeIndex - 2, sw.activeIndex + 2];
    indices.forEach(function (i) {
      var slide = sw.slides[i];
      if (!slide) return;
      var v = slide.querySelector('video');
      if (v && v.readyState < 3) {  // HAVE_FUTURE_DATA = 3
        v.load();
      }
    });
  }
}

  function bootSection(sectionEl) {
    var swiperEl = sectionEl.querySelector('.u-video-slider__swiper');
    if (!swiperEl) return;
    loadLazyLoad(function () {
      new LazyLoad({ container: sectionEl });
      loadSwiper(function () {
        initSlider(swiperEl);
      });
    });
  }

  function bootAll() {
    document.querySelectorAll('.u-video-slider').forEach(bootSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      bootSection(e.target);
    });
  }

})();
